var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8728 13.8287L6.52192 64.4971C5.89616 65.5808 5.56506 66.8094 5.56155 68.0608C5.55805 69.3121 5.88227 70.5426 6.50195 71.6298C7.12164 72.717 8.01519 73.6229 9.09371 74.2575C10.1722 74.8922 11.3981 75.2333 12.6494 75.2471H73.3511C74.6024 75.2333 75.8283 74.8922 76.9068 74.2575C77.9853 73.6229 78.8789 72.717 79.4986 71.6298C80.1182 70.5426 80.4425 69.3121 80.439 68.0608C80.4355 66.8094 80.1043 65.5808 79.4786 64.4971L49.1278 13.8287C48.489 12.7756 47.5895 11.9049 46.5162 11.3006C45.4429 10.6964 44.232 10.3789 43.0003 10.3789C41.7685 10.3789 40.5576 10.6964 39.4843 11.3006C38.411 11.9049 37.5116 12.7756 36.8728 13.8287Z",
    fill: "white",
    stroke: "#E92525",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32.25V46.5833",
    stroke: "#E92525",
    strokeWidth: 9.32389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60.916H43.0366",
    stroke: "#E92525",
    strokeWidth: 9.32389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.81dfb9ed2b5e04c931c09d1b720dbb2e.svg";
export { ForwardRef as ReactComponent };